import { Button, Col, Form, Input, Row, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/AddArticle.css';

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 15 },
};

function AddBanner(props) {
  const [bannerId, setBannerId] = useState(props.match.params.id);
  const [fields, setFields] = useState([]);
  const [imageUrl, setImageUrl] = useState('');
  const [isNewUpload, setIsNewUpload] = useState(false); // 新增状态标记
  const [pageType, setPageType] = useState('home'); // 页面类型状态

  useEffect(() => {
    if (bannerId) {
      getBannerInfo()
    }
  }, [bannerId])

  const getBannerInfo = () => {
    axios({
      method: 'get',
      url: servicePath.getBannerInfo + "/" + bannerId,
    }).then(res => {
      if (res.data.code == 1) {
        const data = res.data.data;
        setFields([
          { name: ['banner', 'url'], value: data.url },
          { name: ['banner', 'type'], value: data.type },
          { name: ['banner', 'page_type'], value: data.page_type || 'home' }
        ]);
        setImageUrl(data.src);
        setPageType(data.page_type || 'home');
      }
    })
  }

  const onFinish = values => {
    const formData = new FormData();
    formData.append("url", values.banner.url);
    formData.append("type", values.banner.type);
    formData.append("page_type", values.banner.page_type || 'home');
    
    // 添加图片文件到表单数据
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput && fileInput.files[0]) {
      formData.append("file", fileInput.files[0]);
    }
  
    if (bannerId) {
      formData.append("id", bannerId);
      axios({
        method: 'post',
        url: servicePath.editBanner,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res.data.code == 1) {
          message.success('修改成功');
          props.history.push('/banner/list');
        }
      })
    } else {
      axios({
        method: 'post',
        url: servicePath.addBanner,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res.data.code == 1) {

          message.success('添加成功');
          props.history.push('/banner/list');
        }
        // console.log('res:', res, imageUrl);
      }).catch(err => {
        console.log('err:', err);
      })
    }
  };

  const uploadImage = (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.error('未选择文件');
      return;
    }

    setIsNewUpload(true); // 标记为新上传
    const reader = new FileReader();
    
    reader.onload = () => {
      setImageUrl(reader.result);
    };
    
    reader.onerror = (error) => {
      console.error('文件读取错误:', error);
    };
    
    reader.readAsDataURL(file);
  }

  return (
    <Form 
      encType="multipart/form-data"
      name="banner-form" 
      fields={fields} 
      onFinish={onFinish}
      method="post" 
      enctype="multipart/form-data"
      {...layout}
    >
      <Row gutter={12}>
        <Col span={20}>
          {bannerId && <Form.Item label="Banner ID">
            <Input defaultValue={bannerId} disabled />
          </Form.Item>}
          
          <Form.Item 
            label="链接地址" 
            name={['banner', 'url']}
            rules={[{ required: false }]}  // 修改为不强制要求
          >
            <Input placeholder="请输入链接地址（可选）" />
          </Form.Item>
          
          <Form.Item 
            label="类型" 
            name={['banner', 'type']}
            rules={[{ required: true, message: '必填' }]}
          >
            <Input placeholder="wx/web" />
          </Form.Item>
          
          <Form.Item 
            label="页面类型" 
            name={['banner', 'page_type']}
            rules={[{ required: true, message: '必填' }]}
          >
            <Input placeholder="home/news" />
          </Form.Item>
          
          <Form.Item label="广告图片">
            <input 
              type="file" 
              name='file'
              onChange={uploadImage} 
              accept="image/*" 
              style={{ marginBottom: 10 }}
            />
            {(imageUrl || isNewUpload) && (
              <img 
                src={isNewUpload ? imageUrl : servicePath.serverUrl + imageUrl}
                style={{
                  width: '200px',
                  height: 'auto',
                  minHeight: '20px',
                  padding: '20px 0',
                  display: 'block'
                }} 
                alt="banner" 
              />
            )}
            <div style={{ padding: '10px 0' }}>
              建议图片尺寸：(336px × 284px)
            </div>
          </Form.Item>
        </Col>
        
        <Col span={4}>
          <Button 
            type="primary" 
            size="large" 
            htmlType="submit"
            style={{ width: '100%' }}
          >
            {bannerId ? '修改Banner' : '发布Banner'}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export default AddBanner